<div class="t-popup popup-transfer-appointments" [dir]="direction">
  <div class="t-popup-close"></div>
  <div class="t-popup-frame" cdkDrag cdkDragBoundary=".t-popup">
    <div class="t-popup-body">
      <button
        class="t-btn-popup-close"
        aria-label="close popup"
        matTooltip="{{ 'appointments.gui.tooltips.Cancel' | translate }}"
        (click)="close()"
      ></button>

      <h2 style="cursor: grab" cdkDragHandle>
        {{ "appointments.gui.labels.Transfer Appointments" | translate }}
      </h2>

      <div class="transfer-subtitle">
        <span>{{ sourceDate | date : "dd.MM.yy" }}</span>
        <span *ngIf="resourceLabel"> &#8226; {{ resourceLabel }}</span>
      </div>

      <div class="l-flex l-flex-w t-fieldmargin">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label class="nowrap">
              {{ "appointments.gui.labels.new date" | translate }}
            </label>
            <i class="t-sep"></i>
            <input
              [matDatepicker]="transferTargetDate"
              [(ngModel)]="targetDate"
              [min]="minDate"
              class="t-field-text w100"
              readonly
              (click)="transferTargetDate.open()"
            />
            <img
              src="../../assets/icons/date.svg"
              (click)="transferTargetDate.open()"
              style="margin-inline-start: -1.8em; cursor: pointer"
            />
            <mat-datepicker #transferTargetDate startView="month"></mat-datepicker>
          </div>
        </div>
      </div>

      <div class="l-flex l-flex-w t-fieldmargin">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label class="nowrap">
              {{
                (byRoom ? "appointments.gui.label.rooms" : "appointments.gui.labels.Doctors")
                  | translate
              }}
            </label>
            <i class="t-sep"></i>
            <select class="t-field-text w100" [(ngModel)]="targetResourceId">
              <option *ngFor="let resource of resourceOptions" [ngValue]="resource.id">
                {{ resource.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="transfer-list-header" *ngIf="appointments?.length">
        <button class="btn-select-all" (click)="toggleAll()">
          {{
            (allSelected
              ? "appointments.gui.buttons.Clear Selection"
              : "appointments.gui.buttons.Transfer All"
            ) | translate
          }}
        </button>
        <span class="transfer-count">
          {{ selectedCount }} / {{ appointments.length }}
        </span>
      </div>

      <div class="transfer-list" *ngIf="appointments?.length; else noAppointments">
        <div
          class="transfer-row"
          *ngFor="let appointment of sortedAppointments"
          [class.is-selected]="isSelected(appointment)"
          (click)="toggle(appointment)"
        >
          <mat-checkbox
            [checked]="isSelected(appointment)"
            (click)="$event.stopPropagation()"
            (change)="toggle(appointment)"
          ></mat-checkbox>
          <span class="transfer-hour">{{ appointmentHour(appointment) }}</span>
          <span class="transfer-patient">{{ patientName(appointment) }}</span>
          <span class="transfer-exam">{{ examName(appointment) }}</span>
        </div>
      </div>

      <ng-template #noAppointments>
        <p class="transfer-empty">
          {{ "appointments.gui.labels.No appointments on this date" | translate }}
        </p>
      </ng-template>

      <div class="transfer-error" *ngIf="error">{{ error }}</div>

      <div class="transfer-actions">
        <button
          class="btn-cancel"
          matTooltip="{{ 'appointments.gui.tooltips.Cancel' | translate }}"
          (click)="close()"
        >
          {{ "appointments.gui.buttons.Cancel" | translate }}
        </button>
        <button
          class="btn-ok"
          [disabled]="pending || !appointments?.length"
          matTooltip="{{ 'appointments.gui.tooltips.Transfer Appointments' | translate }}"
          (click)="confirm()"
        >
          {{ "appointments.gui.buttons.Transfer" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
